export default __webpack_public_path__ + "static/media/Thumb-2.19cf36c7.png";